import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { delay, firstValueFrom, of, switchMap } from 'rxjs';
import { UserProfile } from 'src/app/pages/my-account/interfaces/company-settings.interface';
import { MyAccountService } from 'src/app/pages/my-account/services/my-acount.service';
import { UserService } from 'src/app/services/user.service';



export interface NavSection {
  id: string;
  title: string;
  children: NavSectionChildren[];
}

export interface NavSectionChildren {
  title: string;
  path: string;
  icon: string;
  isNew?: boolean;
}

export enum NavbarSectionEnum {
  HOME = "HOME",
  MANAGEMENT = "MANAGEMENT",
  ACTIVE_ROUTES = "ACTIVE_ROUTES",
  EXPENSES_CONTROL = "EXPENSES_CONTROL",
  CONTACT_SUPPORT = "CONTACT_SUPPORT"
}


@Injectable({
  providedIn: 'root',
})
export class NavigationService {

  constructor(
    private translate: TranslateService,
    private accountService: MyAccountService
  ) { }

  async getSections(): Promise<NavSection[]> {
    const sections = [
      {
        id: "HOME",
        title: '',
        children: [
          {
            title: this.translate.instant('home'),
            path: '',
            icon: '../../assets/icons/navbar/nav-home.svg',
          }
        ],
      },
      {
        id: "MANAGEMENT",
        title: this.translate.instant('management'),
        children: [
          {
            title: this.translate.instant('fleet'),
            path: 'fleets',
            icon: 'assets/icons/navbar/nav-fleets.svg',
            isNew: false,
          },
          {
            title: this.translate.instant('addresses'),
            path: 'addresses',
            icon: 'assets/icons/navbar/nav-address.svg',
            isNew: false,
          },
          {
            title: this.translate.instant('employees'),
            path: 'users',
            icon: 'assets/icons/navbar/nav-users.svg',
            isNew: false,
          },
          {
            title: this.translate.instant('vehicle-storage'),
            path: 'vehicle-storages',
            icon: 'assets/icons/navbar/nav-campas.svg',
            isNew: true,
          },
        ],
      },
      {
        id: "ACTIVE_ROUTES",

        title: this.translate.instant('activeRoutesVisualization'),
        children: [
          {
            title: this.translate.instant('servicesTitle'),
            path: 'services',
            icon: 'assets/icons/navbar/nav-services.svg',
            isNew: false,
          },
          {
            title: this.translate.instant('activeRoutes'),
            path: 'active-routes',
            icon: 'assets/icons/navbar/nav-routes.svg',
            isNew: false,
          },
        ],
      },
      {
        id: "EXPENSES_CONTROL",
        title: this.translate.instant('expenseControl'),
        children: [
          {
            title: this.translate.instant('billingReceipts'),
            path: 'billing',
            icon: 'assets/icons/navbar/nav-billing.svg',
            isNew: false,
          },
          {
            title: this.translate.instant('reports'),
            path: 'reports',
            icon: 'assets/icons/navbar/nav-chart-bar.svg',
          },

        ],
      },
    ];

    return sections;
  }

  getAccountSections(): NavSection[] {
    return [
      {
        id: "CONTACT_SUPPORT",
        title: '',
        children: [
          {
            title: this.translate.instant('contactSupport'),
            path: '/',
            icon: '../../assets/icons/navbar/nav-support.svg',
          },
        ],
      },
    ];
  }

  getWorkshopReport(): NavSectionChildren {
    return {
      title: this.translate.instant('reportsWorkShopTitle'),
      path: 'workshop-report',
      icon: '../../assets/icons/navbar/nav-chart-bar.svg',
    }
  }
}


